// Shared flag: true while the first-run guided tour is walking the user through
// the app. Gated features (Explain, Audio) unlock during the tour so new users
// experience them before hitting the paywall.
export const tourActive = () => {
  try {
    return localStorage.getItem("cb_tour_active") === "1";
  } catch {
    return false;
  }
};
